<template>
  <el-dialog
    class="order-package-detail-modal"
    width="90%"
    title="包裹明细"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <data-table :columns="columns" :list="list" />
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import DataTable from '@/components/DataTable'
import { DetailDelivery } from '../services'
export default {
  name: 'OrderPackageDetailModal',
  components: { DataTable },
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      list: [],
      columns: [
        {
          name: '序号',
          code: 'idx',
          minWidth: '40px',
          flexWidth: 0.4
        },
        {
          name: '名称',
          code: 'partName',
          minWidth: '120px',
          flexWidth: 1.2
        },
        {
          name: '编号',
          code: 'partCode',
          minWidth: '120px',
          flexWidth: 1.2
        },
        {
          name: '数量',
          code: 'qtyDelivering',
          minWidth: '60px',
          flexWidth: '0.6'
        }
      ]
    }
  },
  methods: {
    init (deliveryId) {
      this.getDeliveryInfoByPackage(deliveryId)
      return this.open()
    },
    getDeliveryInfoByPackage (deliveryId) {
      this.loading = true
      return DetailDelivery(deliveryId).then((ans) => {
        this.list = ans.deliveringOrderItems || []
      }).catch(() => {
        this.$message.error('加载包裹信息失败')
        this.close(false)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.order-package-detail-modal
  .el-dialog
    max-width 768px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
</style>
